/* ─── Blu Butterfly · Screen Magic ───────────────────────────────────────── */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var W = window.innerWidth, H = window.innerHeight;
  window.addEventListener('resize', function () { W = window.innerWidth; H = window.innerHeight; });

  /* ── Audio ──────────────────────────────────────────────────────────────── */
  var AC = window.AudioContext || window.webkitAudioContext;
  var ac = null;
  function unlockAudio() {
    if (ac) return;
    try { ac = new AC(); } catch (e) {}
    document.removeEventListener('click',      unlockAudio);
    document.removeEventListener('scroll',     unlockAudio);
    document.removeEventListener('touchstart', unlockAudio);
  }
  ['click','scroll','touchstart'].forEach(function (ev) {
    document.addEventListener(ev, unlockAudio, { passive: true, once: true });
  });
  function sparkleSound() {
    if (!ac) return;
    [0, 5, 12].forEach(function (semitone) {
      try {
        var osc = ac.createOscillator(), gain = ac.createGain();
        osc.connect(gain); gain.connect(ac.destination);
        var freq = (1800 + Math.random() * 1600) * Math.pow(2, semitone / 12);
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, ac.currentTime);
        osc.frequency.exponentialRampToValueAtTime(freq * 1.6, ac.currentTime + 0.06);
        gain.gain.setValueAtTime(0.05, ac.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + 0.18);
        osc.start(ac.currentTime); osc.stop(ac.currentTime + 0.2);
      } catch (e) {}
    });
  }

  /* ── CSS ────────────────────────────────────────────────────────────────── */
  var css = document.createElement('style');
  css.textContent =
    /* Left wing: rotates on Y axis, pivoting at right edge (the body/spine) */
    '@keyframes bbFlapL{' +
      '0%{transform:rotateY(0deg);animation-timing-function:cubic-bezier(.6,0,.8,.45)}' +
      '30%{transform:rotateY(68deg);animation-timing-function:linear}' +
      '50%{transform:rotateY(68deg);animation-timing-function:cubic-bezier(.2,.6,.4,1)}' +
      '100%{transform:rotateY(0deg)}' +
    '}' +
    /* Right wing: mirror of left */
    '@keyframes bbFlapR{' +
      '0%{transform:rotateY(0deg);animation-timing-function:cubic-bezier(.6,0,.8,.45)}' +
      '30%{transform:rotateY(-68deg);animation-timing-function:linear}' +
      '50%{transform:rotateY(-68deg);animation-timing-function:cubic-bezier(.2,.6,.4,1)}' +
      '100%{transform:rotateY(0deg)}' +
    '}' +
    '@keyframes bbFadeIn{from{opacity:0}to{opacity:1}}' +
    '@keyframes bbDust{0%{opacity:.9;transform:translate(0,0) scale(1)}' +
      '100%{opacity:0;transform:translate(var(--dx),var(--dy)) scale(.05)}}' +
    /* Outer container */
    '.bb-b{position:fixed;pointer-events:none;z-index:9999;animation:bbFadeIn .4s ease forwards}' +
    /* 3D perspective wrapper — perspective value set inline per butterfly size */
    '.bb-fly3d{width:100%;height:100%;display:flex;}' +
    /* Each wing clips to its half of the full image */
    '.bb-wing{height:100%;overflow:hidden;position:relative;}' +
    /* Left wing pivots at right edge (body spine) */
    '.bb-wL{width:50%;transform-origin:right center;animation:bbFlapL 500ms ease-in-out infinite;}' +
    /* Right wing pivots at left edge (body spine) */
    '.bb-wR{width:50%;transform-origin:left center;animation:bbFlapR 500ms ease-in-out infinite;}' +
    /* Full image anchored left inside left-wing clip zone */
    '.bb-imgL{position:absolute;left:0;top:0;width:200%;height:100%;display:block;}' +
    /* Full image anchored right inside right-wing clip zone */
    '.bb-imgR{position:absolute;right:0;top:0;width:200%;height:100%;display:block;}' +
    '.bb-d{position:fixed;pointer-events:none;z-index:9998;border-radius:50%;' +
      'animation:bbDust 1.2s ease-out forwards}';
  document.head.appendChild(css);

  /* ── Config ─────────────────────────────────────────────────────────────── */
  var imgUrl     = window.BB_FLY_IMG || '';
  var HERO_SAFE  = 0.30;
  var REGULAR_SZ = 38;
  var MAX_REG    = 5;
  var activeReg  = 0;
  var paletteInUse = [];

  function pickPalette() {
    var avail = [];
    for (var i = 0; i < PALETTES.length; i++) {
      if (paletteInUse.indexOf(i) === -1) avail.push(i);
    }
    if (avail.length === 0) avail = PALETTES.map(function (_, i) { return i; });
    var idx = avail[Math.floor(Math.random() * avail.length)];
    paletteInUse.push(idx);
    return idx;
  }

  function releasePalette(idx) {
    var pos = paletteInUse.indexOf(idx);
    if (pos !== -1) paletteInUse.splice(pos, 1);
  }

  var PALETTES = [
    'hue-rotate(220deg) saturate(0.65) brightness(1.65)',  /* soft pink      */
    'hue-rotate(340deg) saturate(0.60) brightness(1.65)',  /* blush rose     */
    'hue-rotate(90deg)  saturate(0.55) brightness(1.65)',  /* mint green     */
    'hue-rotate(30deg)  saturate(0.60) brightness(1.65)',  /* peach          */
    'hue-rotate(50deg)  saturate(0.50) brightness(1.80)',  /* butter yellow  */
    'hue-rotate(270deg) saturate(0.50) brightness(1.60)',  /* lilac          */
    'hue-rotate(5deg)   saturate(0.65) brightness(1.60)',  /* coral          */
  ];

  function rand(a, b) { return Math.random() * (b - a) + a; }

  /* ── Safe zone helpers ──────────────────────────────────────────────────── */
  function safeMinY() { return H * HERO_SAFE; }

  /* Returns bounds of the product carousel in viewport coords, or null */
  function productBounds() {
    var el = document.querySelector('.bb-corner__carousel-wrap') ||
             document.querySelector('.bb-corner__grid');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > H) return null;
    return {
      l: Math.max(0, r.left),
      r: Math.min(W, r.right),
      t: Math.max(safeMinY(), r.top),
      b: Math.min(H, r.bottom)
    };
  }

  /* Returns viewport positions of visible product images */
  function productTargets() {
    var out = [];
    document.querySelectorAll('.bb-corner__image-wrap').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.top > safeMinY() - 40 && r.bottom < H + 40)
        out.push({ x: r.left + r.width * 0.5, y: r.top + r.height * 0.35 });
    });
    return out;
  }

  /* Nearest edge exit point from current position */
  function nearestEdge(x, y, size) {
    var d = [
      { tx: -size - 20,    ty: y,           dist: x },
      { tx: W + size + 20, ty: y,           dist: W - x },
      { tx: x,             ty: H + size + 20, dist: H - y },
      { tx: x,             ty: -size - 20,   dist: y }
    ];
    d.sort(function (a, b) { return a.dist - b.dist; });
    return { tx: d[0].tx, ty: d[0].ty };
  }

  /* Edge entry position + inward velocity */
  function edgeEntry(minY) {
    var edge = Math.floor(Math.random() * 4);
    var safe = minY || safeMinY();
    var x, y, vx, vy;
    switch (edge) {
      case 0: x = -10;    y = rand(safe, H - 40); vx =  rand(.4,.9); vy = rand(-.3,.3); break;
      case 1: x = W + 10; y = rand(safe, H - 40); vx = -rand(.4,.9); vy = rand(-.3,.3); break;
      case 2: x = rand(W*.15, W*.85); y = H + 10; vx = rand(-.3,.3); vy = -rand(.4,.9); break;
      default:x = rand(W*.15, W*.85); y = Math.max(safe, 10); vx=rand(-.3,.3); vy= rand(.4,.9);
    }
    return { x: x, y: y, vx: vx, vy: vy };
  }

  /* ── Dust ───────────────────────────────────────────────────────────────── */
  var sndCD = 0;
  function spawnDust(x, y) {
    var cols = ['#C9A84C','#D4B96A','#FAF7F2','#9B80D4','#C9A84C'];
    for (var i = 0; i < 3; i++) {
      (function (d) {
        setTimeout(function () {
          var p = document.createElement('div');
          p.className = 'bb-d';
          var sz = rand(2, 5);
          p.style.left   = (x + rand(-8,8) - sz/2) + 'px';
          p.style.top    = (y + rand(-8,8) - sz/2) + 'px';
          p.style.width  = sz + 'px'; p.style.height = sz + 'px';
          p.style.background = cols[Math.floor(Math.random() * cols.length)];
          p.style.animationDuration = rand(.9,1.4).toFixed(2) + 's';
          p.style.setProperty('--dx', rand(-20,20).toFixed(1) + 'px');
          p.style.setProperty('--dy', rand(-34,-4).toFixed(1) + 'px');
          document.body.appendChild(p);
          setTimeout(function () { p.remove(); }, 1500);
        }, d);
      })(i * 35);
    }
    sndCD--;
    if (sndCD <= 0) { sparkleSound(); sndCD = 30; }
  }

  /* ── Build element ──────────────────────────────────────────────────────── */
  function buildEl(size, flapMs, filter) {
    var el = document.createElement('div');
    el.className = 'bb-b';
    el.style.width = size + 'px'; el.style.height = size + 'px';
    if (filter) el.style.filter = filter;

    /* Perspective container — depth scales with butterfly size for consistent 3D feel */
    var fly = document.createElement('div');
    fly.className = 'bb-fly3d';
    fly.style.perspective = (size * 2) + 'px';

    /* Left wing: full image anchored left, clipped to left half, pivots at right (body) */
    var wL = document.createElement('div');
    wL.className = 'bb-wing bb-wL';
    wL.style.animationDuration = flapMs + 'ms';
    var imgL = document.createElement('img');
    imgL.className = 'bb-imgL'; imgL.src = imgUrl; imgL.alt = '';
    wL.appendChild(imgL);

    /* Right wing: full image anchored right, clipped to right half, pivots at left (body) */
    var wR = document.createElement('div');
    wR.className = 'bb-wing bb-wR';
    wR.style.animationDuration = flapMs + 'ms';
    var imgR = document.createElement('img');
    imgR.className = 'bb-imgR'; imgR.src = imgUrl; imgR.alt = '';
    wR.appendChild(imgR);

    fly.appendChild(wL);
    fly.appendChild(wR);
    el.appendChild(fly);
    return el;
  }

  function setFlap(el, ms) {
    var wL = el.querySelector('.bb-wL');
    var wR = el.querySelector('.bb-wR');
    if (wL) wL.style.animationDuration = ms + 'ms';
    if (wR) wR.style.animationDuration = ms + 'ms';
  }

  /* ── Regular butterfly — wanders whole page below hero ──────────────────── */
  function flyRegular(el, size, flapMs, lifetime, onDone) {
    var e   = edgeEntry();
    var x   = e.x, y = e.y, vx = e.vx, vy = e.vy;
    var minY = safeMinY();
    var tx = rand(W*.1, W*.9), ty = rand(minY, H*.9);
    var tT = 0, tL = rand(80, 180);
    var age = 0, dF = 0, exiting = false;
    var dP = Math.random() * Math.PI * 2;
    var dA = rand(.04,.08), dS = rand(.018,.03);

    document.body.appendChild(el);

    function frame() {
      age++; dP += dS; tT++;

      if (exiting) {
        vx += (tx - x) / (Math.abs(tx - x) + 1) * 0.18;
        vy += (ty - y) / (Math.abs(ty - y) + 1) * 0.18;
        var spd = Math.sqrt(vx*vx + vy*vy);
        if (spd > 3.5) { vx = vx/spd*3.5; vy = vy/spd*3.5; }
        x += vx; y += vy;
        el.style.left = (x-size/2)+'px'; el.style.top = (y-size/2)+'px';
        if (x < -size-20 || x > W+size+20 || y < -size-20 || y > H+size+20) {
          el.remove(); if (onDone) onDone();
        } else {
          requestAnimationFrame(frame);
        }
        return;
      }

      if (tT > tL) {
        tx = rand(W*.1, W*.9); ty = rand(minY + 20, H*.9);
        tT = 0; tL = rand(60, 180);
      }
      var ddx = tx-x, ddy = ty-y, dist = Math.sqrt(ddx*ddx+ddy*ddy)||1;
      vx += (ddx/dist)*.028 + rand(-.014,.014);
      vy += (ddy/dist)*.028 + rand(-.014,.014);
      vy += Math.sin(dP) * dA;
      var spd = Math.sqrt(vx*vx+vy*vy);
      if (spd > 1.1) { vx=vx/spd*1.1; vy=vy/spd*1.1; }

      if (y < minY) vy += 0.15;
      var m = 40;
      if (x < m) vx += .08; if (x > W-m) vx -= .08;
      if (y > H-m) vy -= .08;

      x += vx; y += vy;
      el.style.left = (x-size/2)+'px'; el.style.top = (y-size/2)+'px';

      dF++; if (dF >= 10) { dF = 0; spawnDust(x, y); }

      if (age >= lifetime) {
        exiting = true;
        var edge = nearestEdge(x, y, size);
        tx = edge.tx; ty = edge.ty;
      }

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ── Spawn functions ────────────────────────────────────────────────────── */
  function spawnRegular() {
    if (activeReg >= MAX_REG) return;
    activeReg++;
    var pIdx     = pickPalette();
    var filter   = PALETTES[pIdx];
    var size     = Math.round(rand(34, 42));
    var flapMs   = Math.round(rand(520, 780));
    var lifetime = Math.round(rand(300, 520));
    var el = buildEl(size, flapMs, filter);
    flyRegular(el, size, flapMs, lifetime, function () { activeReg--; releasePalette(pIdx); });
  }

  /* ── Launch ─────────────────────────────────────────────────────────────── */
  for (var i = 0; i < 5; i++) {
    (function (d) { setTimeout(spawnRegular, d); })(1600 + i * 500);
  }
  setInterval(spawnRegular, 2200);

})();
